import type {
    Contract,
    LicenseInfo,
    LicenseResponse,
    LocationsLicenseOverview,
} from '@/services/types';

import type { ClientLicense } from './types';

export function toLocationLicenses(rows: LocationsLicenseOverview[]): LocationsLicenseOverview[] {
    return rows.map((row) => ({
        contractId: row.contractId,
        description: row.description,
        licenses: row.licenses,
        locationId: row.locationId,
    }));
}

export function toClientLicenses(rows: LicenseResponse[]): ClientLicense[] {
    return rows.map((row) => ({
        id: row.clientLicenseId,
        licenseId: row.licenseId,
        name: row.name,
        numLicenses: row.numLicenses,
        left: row.left,
    }));
}

/** The licence catalogue and contracts need no reshaping; the body is the list. */
export function toList<T extends LicenseInfo | Contract>(rows: T[]): T[] {
    return rows;
}
